import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { BACKEND } from "../config/configEnvs";

/**
 * Hook para notificaciones en tiempo real de correo.
 * @param {string} token - JWT del usuario
 * @param {string|string[]} mailAccountIds - Una o varias cuentas conectadas a la vez
 * @param {function} onNewMessage - Callback cuando llega un nuevo correo
 */
export function useMailSocket(token, mailAccountIds, onNewMessage) {
  const socketRef = useRef(null);
  const ids = Array.isArray(mailAccountIds)
    ? mailAccountIds
    : mailAccountIds
      ? [mailAccountIds]
      : [];

  useEffect(() => {
    const authToken = token || localStorage.getItem("authToken");

    if (!authToken) {
      console.warn("[MailSocket] Sin token, no se conecta");
      return;
    }

    const socket = io(BACKEND, {
      auth: { token: authToken },
      withCredentials: true,
      autoConnect: true,
    });
    socketRef.current = socket;

    socket.on("connect", () => {
      if (ids.length > 0) {
        const payload =
          ids.length === 1
            ? { mailAccountId: ids[0] }
            : { mailAccountIds: ids };
        socket.emit("subscribe", payload);
      }
    });

    socket.on("newMessage", (data) => {
      onNewMessage(data);
    });

    socket.on("disconnect", (reason) => {
      console.warn("[MailSocket] Desconectado:", reason);
    });

    socket.on("connect_error", (err) => {
      console.error("[MailSocket] Error de conexión:", err.message);
    });

    return () => {
      if (ids.length > 0) {
        const payload =
          ids.length === 1
            ? { mailAccountId: ids[0] }
            : { mailAccountIds: ids };
        socket.emit("unsubscribe", payload);
      }
      socket.disconnect();
      socketRef.current = null;
    };
  }, [token, JSON.stringify(ids), onNewMessage]);

  return socketRef;
}
